
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linga-bhairavi/[region]/[lang]/topic/[topic]",
      function () {
        return require("private-next-pages/linga-bhairavi/[region]/[lang]/topic/[topic]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/linga-bhairavi/[region]/[lang]/topic/[topic]"])
      });
    }
  